import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { FunnelMap } from './components/FunnelMap';
import { MetaPixel } from './components/MetaPixel';
import { BridgePage } from './pages/BridgePage';
import { SalesPage } from './pages/SalesPage';
import { RetargetingPage } from './pages/RetargetingPage';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3f8exzgol9nsm">
      <div className="w-full min-h-screen bg-cream font-body text-ink" data-id="element-1" data-mp="2rkx5fixi2lol">
        <MetaPixel data-id="element-2" data-mp="2rit1j0zlpmob" />
        <Routes data-id="element-3" data-mp="2mlu9qp3etrta">
          <Route path="/" element={<BridgePage data-id="element-5" data-mp="2mmvk0rclqa9y" />} data-id="element-4" data-mp="2mmceka451ect" />
          <Route path="/protocolo" element={<SalesPage data-id="element-7" data-mp="31aqh0jxn70su" />} data-id="element-6" data-mp="2mnnfm2678808" />
          <Route path="/retargeting" element={<RetargetingPage data-id="element-9" data-mp="31c1ha9rvpqf7" />} data-id="element-8" data-mp="31ayq00qn9lyr" />
        </Routes>
        <FunnelMap data-id="element-10" data-mp="2wjgrrkg09zhh" />
      </div>
    </BrowserRouter>;
}